export default class RequisitionsLoader{

  static removeLoader = () => {
    var list = document.getElementsByClassName("requisition-loader");
    for(var i = list.length - 1; 0 <= i; i--){
      if(list[i] && list[i].parentElement)
      list[i].parentElement.removeChild(list[i]);
    }
  }

  static createLoader = () => {
    const container = document.createElement("div");
    container.setAttribute("class", 'requisition-loader');
    document.body.appendChild(container);

    const box = document.createElement("span");
    box.setAttribute("class", 'requisition-loader__loaderbox');
    container.appendChild(box);

    const loader = document.createElement("span");
    loader.setAttribute("class", 'requisition-loader__loader');
    box.appendChild(loader);
  }
}



// WEBPACK FOOTER //
// ./src/utils/requisitions/RequisitionsLoader.js